import { c as _c } from "react/compiler-runtime";
export default function Pause(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M7,21a1,1,0,0,1-1-1V4A1,1,0,0,1,8,4V20A1,1,0,0,1,7,21Zm11-1V4a1,1,0,0,0-2,0V20a1,1,0,0,0,2,0Z" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg aria-label="Icon Pause" className={className} fill="currentColor" height="24" id="SH_Icon" role="img" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}